<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-fullHeight">
            <div class="cs-course-container" v-show="isShowCourseSchedule">
              <el-row>
                <el-col :span="18" class="border-right cs-left-container">
                  <span class="cs-title">课程安排</span>
                  <el-row>
                    <el-col>
                      <el-row class="cs-filter-row">
                        <el-col :span="4">
                          <el-select placeholder="请选择课程类型" size="medium" v-model="selectedCourseType" @change="onCourseTypeChanged" class="margin-right-20px">
                            <el-option v-for="item in courseTypes" :key="item.Value" :label="item.Text" :value="item.Value">
                            </el-option>
                          </el-select>
                        </el-col>
                           <el-col :span="4" v-if="selectedCourseType == 3">
                          <el-select placeholder="请选择业务" size="medium" v-model="selectedTrainingCategoryId" @change="onTrainingCategoryChanged" class="margin-right-20px">
                            <el-option v-for="item in trainingCategoryList" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4" v-if="selectedCourseType == 3">
                          <el-select placeholder="请选择学期" size="medium" v-model="selectedTrainingTermId" @change="onTrainingTermChanged" class="margin-right-20px">
                            <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4" v-if="selectedCourseType == 3">
                          <el-select placeholder="请选择校区" size="medium" v-model="selectedCampusId" @change="onCampusChanged" class="margin-right-20px">
                            <el-option v-for="item in campusList" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4" v-if="selectedCourseType == 1">
                          <el-select placeholder="请选择学期" size="medium" v-model="selectedUniversityTermId" @change="onTermChanged" class="margin-right-20px">
                            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4" v-if="selectedCourseType == 1">
                          <el-select placeholder="请选择学校" filterable v-model="selectedUniversityGroupNumber" size="medium" @change="onUniversityChanged" class="margin-right-20px">
                            <el-option v-for="item in universityList" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber">
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="4">
                          <el-tooltip class="item" :disabled="planDisabled" effect="dark" content="请先选择学校" placement="top">
                            <el-select placeholder="请选择方案" :disabled="planDisabled" size="medium" v-model="selectedPlanId" @change="onPlanChanged" class="margin-right-20px">
                              <el-option v-for="item in speedupCoursePlans" :key="item.Id" :label="getPlanItemText(item)" :value="item.Id">
                              </el-option>
                            </el-select>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4">
                          &nbsp;
                          <el-button v-if="showSelectedPlan()" type="primary" size="medium" @click="selectActivePlan" class="margin-right-20px">选中方案</el-button>
                        </el-col>
                  
                        <el-col :span="4" class="cs-course-label">
                          <strong>
                            <label>总课程数量：</label>
                          </strong>
                          <label v-text="totalCourseCount" class="margin-right-20px"></label>
                        </el-col>
                        </el-row>
                      <el-row>
                        <el-col class="text-right top-button-container">
                          <div v-if="!USERMANAGER.isSales && !USERMANAGER.isReceptionist && !USERMANAGER.isAssistant">
                            <el-button v-if="!!selectedPlanId" type="primary" size="medium" @click="verifyCourseCount">验证方案课程数量</el-button>
                            <el-button v-if="!!selectedPlanId" type="primary" size="medium" @click="verify">验证方案</el-button>
                            <el-button v-if="!!selectedCourseItem && !!selectedPlanListCourseItem" type="primary" size="medium" @click="compareCourse">对比课程</el-button>
                            <el-button v-if="!!selectedCourseItem && (selectedCourseItem.CourseClass > 0 || selectedCourseItem.IsSplitCourse)" type="primary" size="medium" @click="separateCancel">取消分班</el-button>
                            <el-button :disabled="selectedBlockIndex < 0" :type="btnSeparateType" size="medium" @click="separateCourse">自动分班</el-button>
                            <el-button :disabled="selectedBlockIndex < 0" :type="btnSeparateType" size="medium" @click="separateCourseByStudents">按人数分班</el-button>
                            <el-button :disabled="selectedBlockIndex < 0" :type="btnAddType" size="medium" @click="addCourseToPlan">添加至</el-button>
                            <el-alert v-show="isShowError" :closable="false" :title="errorMessage" type="error">
                            </el-alert>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row class="grid-content">
                        <el-col :span="5">
                          <!-- <speedup-course-summary-list ref="speedupCourseListComponent" :termId="selectedTermId" :planId="selectedPlanId" :planDetail="selectedPlanCourses" :universityGroupNumber="selectedUniversityGroupNumber" @selectCourse="selectCourse"  v-on:courseCountChanged="onCourseCountChanged"></speedup-course-summary-list> -->
                         <speedup-course-summary-list ref="speedupCourseListComponent" :courseType="selectedCourseType" :data="speedupCourseListData" @selectCourse="selectCourse"  v-on:courseCountChanged="onCourseCountChanged"></speedup-course-summary-list>
                        </el-col>
                        <el-col :span="19">
                          <div class="calendar-container">
                            <courseCalendar v-loading="isLoading" :options="{start:GLOBAL.courseScheduleSetting.start, end:GLOBAL.courseScheduleSetting.end}" :schedules="courseSchedules" @editBlock="selectCourseSchedule" @editDoubleClick="showCourse"></courseCalendar>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6" class="cs-right-container">
                  <speedup-course-plan-list :courseType="selectedCourseType" :termId="this.selectedTermId" :universityGroupNumber="selectedUniversityGroupNumber" :campusId="selectedCampusId" :plans="speedupCoursePlans" @selectCourse="selectPlanListCourse" @loadDetail="loadPlanDetail" @addPlan="addPlan" @deletePlan="deletePlan" @deleteCourse="deleteCourse"></speedup-course-plan-list>
                </el-col>
              </el-row>
            </div>
            <div class="cs-course-edit-container" v-show="!isShowCourseSchedule">
              <addCourseToPlanComponent :options="{start:GLOBAL.courseScheduleSetting.start, end:GLOBAL.courseScheduleSetting.end}" :course-data="selectedCourse" @close="closeAddCourse"></addCourseToPlanComponent>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="课程详情" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayCourseDetail" top="15vh">
      <speedupCourseScheduleDetail :data="courseDetailData" class="popup-window" v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></speedupCourseScheduleDetail>
    </el-dialog>
    <el-dialog title="课程对比" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayCourseCompare" top="15vh">
      <speedupCourseCompare :data="courseCompareData" class="popup-window" v-on:dialogFormVisibleEvent="onCourseCompareDialogFormVisibleEvent"></speedupCourseCompare>
    </el-dialog>
    <el-dialog title="验证方案" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayCourseValidation" top="15vh">
      <speedupCourseValidation :data="courseValidationData" class="popup-window" v-on:dialogFormVisibleEvent="onCourseValidationDialogFormVisibleEvent"></speedupCourseValidation>
    </el-dialog>
    <el-dialog title="验证方案课程数量" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayCourseCountValidation" top="15vh">
      <speedupCourseCountValidation :data="courseCountValidationData" class="popup-window" v-on:dialogFormVisibleEvent="onCourseCountValidationDialogFormVisibleEvent"></speedupCourseCountValidation>
    </el-dialog>
    <el-dialog title="分班" :center="true" :close-on-click-modal="false" width="728px" :visible.sync="displaySpeedupCourseSplit" top="15vh">
      <speedupCourseSplit :dataIn="speedupCourseSplitData"  class="popup-window" @dialogFormVisibleEvent="onSpeedupCourseSplitVisibleEvent" @splitSuccess="onSplitSuccess"></speedupCourseSplit>
    </el-dialog>
  </div>
</template>


<style lang="scss" scoped>
.cs-contentContainer {
  .cs-right-container {
    padding: 40px 40px 40px 0;
  }
  .cs-left-container {
    padding: 40px 0 40px 40px;
  }
  .cs-course-label {
    text-align: right;
  }
  .grid-content {
    margin-top: 15px;
    .cs-schedule-buttonContainer {
      text-align: right;
    }
    .calendar-container {
      margin: 0 20px;
    }
  }
  .top-button-container {
    padding-right: 20px;
  }
}
</style>

<script>
import courseCalendar from "../../components/courseCalendar";
import speedupCourseSummaryList from "../../components/speedupCourse/speedupCourseSummaryList";
import speedupCoursePlanList from "../../components/speedupCourse/speedupCoursePlanList";
import speedupCourseScheduleDetail from "../../components/speedupCourse/speedupCourseScheduleDetail";
import addCourseToPlanComponent from "../../components/speedupCourse/addCourseToPlan";
import speedupCourseCompare from "../../components/speedupCourse/speedupCourseCompare";
import speedupCourseValidation from "../../components/speedupCourse/speedupCourseValidation";
import speedupCourseCountValidation from "../../components/speedupCourse/speedupCourseCountValidation";
import speedupCourseSplit from "../../components/speedupCourse/speedupCourseSplit";
import { getUniversityGroups, getTerms, getTrainingCategoryList, getTrainingTerms, getCategoryCampusList } from "../../service/common.service";

import navigator from "../../components/navigator";
import {
  getSpeedupCoursePlans,
  getSpeedupCourseSchedule,
  getPlanCourseList,
  separateCourse,
  removeSeparateCourse,
  verifyPlan,
  getMoreThanOneCourseData,
  selectPlan
} from "../../service/speedupCourse.service";
import { getColorList, formatTimeToInt60, getCourseType, convertToFloat } from "../../config/mUtils";
import { srcTimesOfDay, srcDaysOfWeek } from "../../service/api-base.service";
export default {
  data() {
    return {
      speedupCourseListData:{},
      dayOfWeekList: srcDaysOfWeek(),
      isShowCourseSchedule: true,
      isShowError: false,
      errorMessage: "",
      courseId: 0,
      teacherId: 0,
      selectedBlockIndex: -1,
      selectedCourseItem: null,
      selectedUniversityGroupNumber: "",
      selectedPlanId: "",
      currentPlanId: 0,
      totalCourseCount: 0,
      universityList: [],
      courseSchedules: [],
      //universityIdList: [],
      speedupCoursePlans: [],
      scheduleData: [],
      colorList: getColorList(),
      displayCourseDetail: false,
      courseDetailData: {},
      selectedCourse: {},
      selectedPlanCourses: [],
      displayCourseCompare: false,
      courseCompareData: {},
      selectedPlanListCourseItem: null,
      displayCourseValidation: false,
      courseValidationData: {},
      displayCourseCountValidation: false,
      courseCountValidationData: {},
      currentTermId: 0,
      termList: [],
      selectedCourseType:1,
      courseTypes:[],
      trainingCategoryList:[],
      selectedTrainingCategoryId:"",
      selectedUniversityTermId: "",
      selectedTrainingTermId:"",
      selectedCampusId:"",
      trainingTermList:[],
      campusList:[], 
      isLoading: false,
      displaySpeedupCourseSplit: false,
      speedupCourseSplitData:{
        termId: 0,
        planId: 0,
        courseId: 0,
        teacherId: 0,
        courseClass: 0,
        courseName: "",
        unavailaleStudentList: []
      }
    };
  },
  components: {
    navigator,
    courseCalendar,
    speedupCourseSummaryList,
    speedupCoursePlanList,
    speedupCourseScheduleDetail,
    addCourseToPlanComponent,
    speedupCourseCompare,
    speedupCourseValidation,
    speedupCourseCountValidation,
    speedupCourseSplit
  },
  created() {
    this.courseTypes = getCourseType(true, this.USERMANAGER.isVocationalTrainingManager);  
    if (this.USERMANAGER.isVocationalTrainingManager){
      this.selectedCourseType = this.GLOBAL.courseType.vocationalTraining;
    }
    getTrainingCategoryList(3).then(result => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;

        if (!!this.trainingCategoryList && this.trainingCategoryList.length> 0){
          this.selectedTrainingCategoryId = this.trainingCategoryList[0].Id;
          this.getCampusList();
          this.getTrainingTermList();
        }
      }
    });

    getUniversityGroups().then(result => {
      if (!!result && result.success) {
        this.universityList = result.data;
      }
    });
    getTerms(false).then(result => {
      if (!!result && result.success) {
        this.termList = result.data;
        let currentTerm = result.data.filter(i => i.IsCurrentTerm);

        if (currentTerm && currentTerm.length > 0) {
          this.currentTermId = currentTerm[0].Id;
          this.selectedUniversityTermId = this.currentTermId;
        }
      }
    });
    this.loadSpeedupCoursePlans();
  },
  computed: {
    btnAddType: function() {
      if (this.selectedBlockIndex < 0) {
        return "info";
      }
      return "primary";
    },
    btnSeparateType: function() {
      if (this.selectedBlockIndex < 0) {
        return "info";
      }
      return "primary";
    },
    planDisabled:function(){
      if (this.selectedCourseType == 1){
        return !this.selectedUniversityGroupNumber;
      }else{
        return !this.selectedTrainingCategoryId || !this.selectedTrainingTermId;
      }
    },
    selectedTermId: function(){
      if (this.selectedCourseType == 1){
        return this.selectedUniversityTermId
      }else{
        return this.selectedTrainingTermId;
      }
    }
  },
  methods: {
    onCourseTypeChanged(){
      this.loadSpeedupCoursePlans();
    },
    onTrainingCategoryChanged(){
      this.selectedTrainingTermId = "";
      this.selectedPlanId = "";
      this.speedupCoursePlans = [];
      this.getCampusList(() => {this.loadSpeedupCoursePlans()});
      this.getTrainingTermList(() => {this.loadSpeedupCoursePlans()});
    },
    onTrainingTermChanged() {
      this.loadSpeedupCoursePlans();
    },
    onCampusChanged(){
       this.loadSpeedupCoursePlans();
    },
    onTermChanged() {
      this.loadSpeedupCoursePlans();
    },
    getCampusList(callback){
      if (!this.selectedTrainingCategoryId) {
        if (callback){
          callback();
        }
        return;
      }

      getCategoryCampusList(this.selectedTrainingCategoryId).then(result =>{
        if (!!result && result.success){
          this.campusList = result.data;
          if (this.campusList.length > 0){
            this.selectedCampusId = this.campusList[0].Id;
          } 
          if (callback){
            callback();
          }
        }

      });
    },
    getTrainingTermList(callback){
      if (!this.selectedTrainingCategoryId) {
        if (callback){
          callback();
        }
        return;
      }

      getTrainingTerms(false, this.selectedTrainingCategoryId).then(result => {
        if (!!result && result.success) {
          this.trainingTermList = result.data;

          if (!!this.trainingTermList && this.trainingTermList.length > 0){
            let currentTerm = this.trainingTermList.find(i => i.IsCurrentTerm);
            if (!!currentTerm){
              this.selectedTrainingTermId = currentTerm.Id;
            }
            if (callback) {
              callback();
            }
          }
        }
      });   
    },
    loadSpeedupCoursePlans() {
      let termId = 0;
      let groupNumber = null;
      let campusId = null;
      if (this.selectedCourseType == 1){
        if (!this.selectedTermId || !this.selectedUniversityGroupNumber){
          this.speedupCoursePlans = [];
           this.selectedPlanId = "";
            this.getspeedupCourseListData();
          return;
        }
        termId = this.selectedTermId;
        groupNumber = this.selectedUniversityGroupNumber;
      }else {
        if (!this.selectedTrainingCategoryId || !this.selectedTrainingTermId || !this.selectedCampusId){
          this.speedupCoursePlans = [];
          this.selectedPlanId = "";
          this.getspeedupCourseListData();
          return;
        }
        termId = this.selectedTrainingTermId;
        campusId = this.selectedCampusId;
      }
      getSpeedupCoursePlans(
        termId,
        groupNumber,
        campusId
      ).then(result => {
        if (!!result && result.success) {
          this.selectedPlanId = "";
          this.speedupCoursePlans = result.data;
          this.getspeedupCourseListData();

        }
      });
    },
    getPlanItemText(item) {
      let text = item.Name;
      if (item.Selected) {
        text += "(已选中)";
      }
      return text;
    },
    getUniversityGroupNumber(){
      let group = this.selectedUniversityGroupNumber;
      if (this.selectedCourseType != 1){
        group = 0;
      }
      return group;
    },
    getCampusId(){
      let campusId = this.selectedCampusId;
      if (this.selectedCourseType != 3){
        campusId = null;
      }
      return campusId;
    },
    selectActivePlan() {
      let message = "选中新方案后，会重置已有的课程分班，是否继续?";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        let plan = this.getSelectedPlan();
        if (plan) {
          
          selectPlan(plan.Id, this.getUniversityGroupNumber(), this.getCampusId()).then(result => {
            if (result && result.success) {
              this.speedupCoursePlans.forEach(element => {
                if (element.Id == plan.Id) {
                  element.Selected = true;
                } else {
                  element.Selected = false;
                }
              });
            }
          });
        }
      })
      .catch(() => {});;
    },
    showSelectedPlan() {
      let plan = this.getSelectedPlan();
      if (plan) {
        if (plan.Selected) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    selectPlanListCourse(course) {
      this.selectedPlanListCourseItem = course;
    },
    compareCourse() {
      this.courseCompareData = {
        termId: this.selectedTermId,
        planId: this.selectedPlanId,
        course1: this.selectedCourseItem,
        course2: this.selectedPlanListCourseItem
      };
      this.displayCourseCompare = true;
    },
    separateCancel() {
      let course = this.selectedCourseItem;
      if (!course) return;
      let message = "您是否要取消课程" + course.CourseName + "的分班?";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          removeSeparateCourse(
            this.selectedPlanId,
            course.CourseId,
            course.TeacherId,
            course.CourseClass
          ).then(result => {
            if (result.success) {
              this.$message({
                message: "取消分班成功",
                type: "success"
              });
              this.$refs.speedupCourseListComponent.loadSpeedupCourseSummary();
            } else {
              if (result.message) {
                this.$message({
                  message: result.message,
                  type: "warning"
                });
              }
            }
          });
        })
        .catch(() => {});
    },
    separateCourseByStudents(){
       if (this.selectedBlockIndex < 0) {
        this.isShowError = true;
        this.errorMessage = "请先选择一个课程可用时间块";
        return;
      }

      let item = this.scheduleData[this.selectedBlockIndex];
      this.speedupCourseSplitData = {
        termId: this.selectedTermId,
        planId: this.selectedPlanId,
        courseId: item.CourseId,
        teacherId: item.TeacherId,
        courseClass: item.CourseClass,
        courseName: item.CourseName,
        unavailaleStudentList: item.UnavailaleStudentList
      };
      this.displaySpeedupCourseSplit = true;
    },
    separateCourse() {
      if (this.selectedBlockIndex < 0) {
        this.isShowError = true;
        this.errorMessage = "请先选择一个课程可用时间块";
      } else {
        let item = this.scheduleData[this.selectedBlockIndex];
        let dayofweek = item.DayOfWeek;
        if (dayofweek == 0) {
          dayofweek = 7;
        }
        let courseName = item.CourseName;
        if (item.CourseClass > 0) {
          courseName += "-分班" + item.CourseClass;
        }
        let message =
          "您是否要对课程" +
          courseName +
          " " +
          this.dayOfWeekList[dayofweek - 1].label +
          " " +
          item.StartTimeText +
          "-" +
          item.EndTimeText +
          "进行分班?";
        this.$confirm(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let studentIds = item.UnavailaleStudentList.map(i => {
              return i.StudentId;
            });
            separateCourse(
              this.selectedTermId,
              this.selectedPlanId,
              item.CourseId,
              item.TeacherId,
              item.CourseClass,
              studentIds
            ).then(result => {
              if (result.success) {
                this.$message({
                  message: "分班成功",
                  type: "success"
                });
                this.$refs.speedupCourseListComponent.loadSpeedupCourseSummary();
              } else {
                if (result.message) {
                  this.$message({
                    message: result.message,
                    type: "warning"
                  });
                }
              }
            });
          })
          .catch(() => {});
      }
    },
    addPlan(plan) {
      this.speedupCoursePlans.push(plan);
    },
    deletePlan(id) {
      let index = this.speedupCoursePlans.findIndex(i => i.Id == id);
      if (index >= 0) {
        this.speedupCoursePlans.splice(index, 1);
      }
      if (this.selectedPlanId == id) {
        this.selectedPlanId = "";
        this.getspeedupCourseListData();
        //this.selectedUniversityGroupNumber = "";
        //this.universityIdList = [];
      }
    },
    deleteCourse(courseData) {
      let planId = courseData.PlanId;
      this.speedupCoursePlans.forEach(element => {
        if (!!element.courseList) {
          let index = element.courseList.findIndex(
            i =>
              i.CourseId == courseData.CourseId &&
              i.TeacherId == courseData.TeacherId &&
              i.CourseClass == courseData.CourseClass
          );
          if (index >= 0) {
            element.courseList.splice(index, 1);
            element.courseList = this.sortCourseList(element.courseList);
          }
        }
      });
      if (
        this.selectedPlanListCourseItem.PlanId == planId &&
        this.selectedPlanListCourseItem.CourseId == courseData.CourseId &&
        this.selectedPlanListCourseItem.TeacherId == courseData.TeacherId &&
        this.selectedPlanListCourseItem.CourseClass == courseData.CourseClass
      ) {
        this.selectedPlanListCourseItem = null;
      }
      this.getspeedupCourseListData();
    },
    closeAddCourse(isReload) {
      this.isShowCourseSchedule = true;
      if (isReload) {
        this.loadPlanDetail(this.selectedPlanId, this.resetSelectedPlanCourses);
      }
    },
    onDialogFormVisibleEvent(visible) {
      this.displayCourseDetail = visible;
    },
    onCourseCompareDialogFormVisibleEvent(visible) {
      this.displayCourseCompare = visible;
    },
    onCourseValidationDialogFormVisibleEvent(visible) {
      this.displayCourseValidation = visible;
    },
    onCourseCountValidationDialogFormVisibleEvent(visible) {
      this.displayCourseCountValidation = visible;
    },
    onSpeedupCourseSplitVisibleEvent(visible){
      this.displaySpeedupCourseSplit = visible;
    },
    onSplitSuccess(){
      this.displaySpeedupCourseSplit = false;
      this.$refs.speedupCourseListComponent.loadSpeedupCourseSummary();
    },
    selectCourseSchedule(index) {
      this.selectedBlockIndex = index;
      this.isShowError = false;
      this.errorMessage = "";
    },
    showCourse(index) {
      this.selectedBlockIndex = index;
      this.isShowError = false;
      this.errorMessage = "";
      let courseData = {};
    
      if (index >= 0 && index < this.scheduleData.length) {
        let plan = this.getSelectedPlan();
        let itemData = this.scheduleData[index];
        if (!!itemData) {
          courseData["courseName"] = itemData.CourseName;
          courseData["courseClass"] = itemData.CourseClass;
          courseData["totalCount"] = itemData.TotalStudentCount;
          courseData["unavailableCount"] = itemData.UnavailableStudentCount;
          courseData["unavailableStudentList"] = itemData.UnavailaleStudentList;
          courseData["planId"] = this.selectedPlanId;
          courseData["plan"] = plan;
          courseData["termId"] = this.selectedTermId;
          courseData["courseId"] = this.selectedCourseItem.CourseId;
          courseData["teacherId"] = this.selectedCourseItem.TeacherId;
          courseData["courseClass"] = this.selectedCourseItem.CourseClass;
          courseData["unavailableCount"] = itemData.UnavailableStudentCount;
          courseData["unavailableTeacherList"] = itemData.UnavailableTeacherList;

        }
      }
      this.courseDetailData = courseData;
      this.displayCourseDetail = true;
    },
    selectCourse(item) {
      this.selectedBlockIndex = -1;
      if (!item) {
        this.courseSchedules = [];
        this.selectedCourseItem = null;
        return;
      }
      this.selectedCourseItem = item;
      this.isLoading = true;
      getSpeedupCourseSchedule(
        this.selectedTermId,
        this.selectedPlanId,
        item.CourseId,
        item.TeacherId,
        item.CourseClass
      ).then(result => {
        
        if (!!result && result.success && !!result.data && result.data.length > 0) {
          let isCurrentData = false;
          let firstItem = result.data[0];
          if (firstItem.CourseId == this.selectedCourseItem.CourseId && firstItem.TeacherId == this.selectedCourseItem.TeacherId &&
            firstItem.CourseClass == this.selectedCourseItem.CourseClass){
            isCurrentData = true;
          }

          if (isCurrentData){
            this.scheduleData = result.data;
            let scheduleList = [];
            let color = this.colorList[0];
            this.scheduleData.forEach((element, index) => {
              let dayofweek = element.DayOfWeek;
              if (dayofweek == 0) {
                dayofweek = 7;
              }
              let percentage = "";
              let tooltipTextList = [];
              tooltipTextList.push(element.StartTimeText + " - " + element.EndTimeText);
              if (!!element.UnavailableTeacherName){
                tooltipTextList.push("不能上课的老师: " + element.UnavailableTeacherName);
              }
              let item = {
                color: color,
                starttime: element.StartTimeText,
                endtime: element.EndTimeText,
                dayofweek: dayofweek,
                title: element.PercentageText,
                text: "",
                tooltipText: "",
                tooltipTextList: tooltipTextList,
                keyValue: index,
                dataId: index
              };
              scheduleList.push(item);
            });
            this.courseSchedules = scheduleList;
          }
        } else {
          this.courseSchedules = [];
        }
        this.isLoading = false;
      }).catch(err =>{
        this.isLoading = false;
      });
    },
    getSelectedPlan() {
      if (!!this.speedupCoursePlans) {
        let plan = this.speedupCoursePlans.filter(
          i => i.Id == this.selectedPlanId
        );
        if (!!plan && plan.length > 0) {
          return plan[0];
        }
      }
      return false;
    },
    addCourseToPlan() {
     
      if (this.selectedBlockIndex < 0) {
        this.isShowError = true;
        this.errorMessage = "请先选择一个课程可用时间块";
      } else {
        this.isShowCourseSchedule = false;
        let plan = this.getSelectedPlan();
        let planText = "";
        if (!!plan) {
          planText = plan.Name;
        }

        let data = {
          courseId: this.selectedCourseItem.CourseId,
          courseName: this.selectedCourseItem.CourseName,
          teacherId: this.selectedCourseItem.TeacherId,
          teacherName: this.selectedCourseItem.TeacherName,
          courseClass: this.selectedCourseItem.CourseClass,
          studentCount: this.selectedCourseItem.StudentCount,
          courseMinutes: this.selectedCourseItem.CourseMinutes,
          termId: this.selectedTermId,
          planId: this.selectedPlanId,
          campusId: this.getCampusId(),
          planName: planText,
          plan: plan,
          dayOfWeek: this.courseSchedules[this.selectedBlockIndex].dayofweek,
          startTime: this.courseSchedules[this.selectedBlockIndex].starttime,
          endTime: this.courseSchedules[this.selectedBlockIndex].endtime,
          unavailableStudentCount: this.scheduleData[this.selectedBlockIndex]
            .UnavailableStudentCount,
          percentageText: this.scheduleData[this.selectedBlockIndex]
            .PercentageText
        };
        this.selectedCourse = data;

      }
    },
    onUniversityChanged() {

      this.loadSpeedupCoursePlans();
      //this.universityIdList = this.selectedUniversityId.split(",");
    },
    onCourseCountChanged(count) {
      this.totalCourseCount = count;
    },
    onPlanChanged(value) {
      //this.selectedUniversityId = "";
      let selectedPlan = this.getSelectedPlan();
      if (selectedPlan) {
        if (!selectedPlan.courseList || selectedPlan.courseList.length == 0) {
          this.loadPlanDetail(
            this.selectedPlanId,
            this.resetSelectedPlanCourses
          );
        } else {
          this.resetSelectedPlanCourses();
        }
      }
      // this.selectedUniversityId = this.universityList[0].IdValue;
      // this.universityIdList = this.selectedUniversityId.split(",");
    },
    resetSelectedPlanCourses() {
      let selectedPlan = this.getSelectedPlan();
      if (!!selectedPlan) {
        this.selectedPlanCourses = selectedPlan.courseList;
      } else {
        this.selectedPlanCourses = [];
      }
      this.getspeedupCourseListData();
    },
    getspeedupCourseListData(){
      this.speedupCourseListData = {
        courseType: this.selectedCourseType,
        termId : this.selectedTermId,
        planId: this.selectedPlanId,
        universityGroupNumber: this.getUniversityGroupNumber(),
        planDetail: this.selectedPlanCourses
      };
    },
    onClickBlock(keyValue) {
      //todo:show details
    },
    sortCourseList(courseList) {
      if (courseList && courseList.length > 0) {
        return courseList.sort((a, b) => {
          let aDayOfWeek = a.DayOfWeek;
          let bDayOfWeek = b.DayOfWeek;
          if (aDayOfWeek == 0) aDayOfWeek = 7;
          if (bDayOfWeek == 0) bDayOfWeek = 7;
          if (aDayOfWeek < bDayOfWeek) {
            return -1;
          } else if (aDayOfWeek > bDayOfWeek) {
            return 1;
          } else {
            let startTimea = formatTimeToInt60(a.StartTimeText);
            let startTimeb = formatTimeToInt60(b.StartTimeText);
            if (startTimea < startTimeb) {
              return -1;
            } else if (startTimea > startTimeb) {
              return 1;
            } else {
              let endTimea = formatTimeToInt60(a.EndTimeText, true);
              let endTimeb = formatTimeToInt60(b.EndTimeText, true);
              if (endTimea < endTimeb) {
                return -1;
              } else if (endTimea > endTimeb) {
                return 1;
              } else {
              }
              return 0;
            }
          }
        });
      } else {
        return courseList;
      }
    },
    loadPlanDetail(planId, callback) {
      getPlanCourseList(this.selectedTermId, planId).then(result => {
        if (!!result && result.success) {
          if (!!this.speedupCoursePlans) {
            let index = this.speedupCoursePlans.findIndex(i => i.Id == planId);
     
            let plan = JSON.parse(
              JSON.stringify(this.speedupCoursePlans[index])
            );
            plan.courseList = this.sortCourseList(result.data);
          
            this.speedupCoursePlans.splice(index, 1, plan);
            if (callback) {
              callback(plan);
            }
           
          }
        }
      });
    },
    verify() {
      if (!this.selectedPlanId || this.selectedPlanId === 0) {
        return;
      }
      let plan = this.getSelectedPlan();
      verifyPlan(this.selectedTermId, this.selectedPlanId).then(result => {
        
        if (!!result && result.success) {
          if (!result.data.HasError) {
            this.$message({
              message: "筛查完成，未找到任何时间冲突",
              type: "success"
            });
          } else {
            let data = {
              tableData: result.data,
              plan: plan,
              termId: this.selectedTermId
            };
            this.courseValidationData = data;
            //this.courseValidationData = result.data;
            //this.courseValidationData['planId'] = this.selectedPlanId;
            this.displayCourseValidation = true;
          }
        } else {
          this.$message({
            message: result.message,
            type: "error"
          });
        }
      });
    },
    verifyCourseCount() {
      if (!this.selectedPlanId || this.selectedPlanId === 0) {
        return;
      }
      let plan = this.getSelectedPlan();

      getMoreThanOneCourseData(this.selectedTermId, this.selectedPlanId).then(
        result => {
          if (!!result && result.success) {
            
            if (
              result.data.StudentList.length == 0 &&
              result.data.TeacherList.length == 0
            ) {
              this.$message({
                message:
                  "学生/老师课程数量筛查完成，未找到同一天上两门课以上的学生/老师",
                type: "success"
              });
            } else {
              let data = {
                tableData: result.data,
                plan: plan,
                termId: this.selectedTermId
              };
              this.courseCountValidationData = data;
              this.displayCourseCountValidation = true;
            }
          } else {
            this.$message({
              message: result.message,
              type: "error"
            });
          }
        }
      );
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/page/admin/speedupCourseSchedule.vue